module.exports = __webpack_public_path__ + "static/media/banned-player.svg.6cdab0b2.png";